// extracted by mini-css-extract-plugin
export default {"base":"ReportingPage_base__yWkDm","searchInfo":"ReportingPage_searchInfo__bSrB8","buttons":"ReportingPage_buttons__kEnTX","btnContainer":"ReportingPage_btnContainer__M6zML"};